export const SUPPORTED_LOCALES = [
  "en",
  "pt",
  "es",
  "fr",
  "it",
  "de",
  "ro",
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "pt";
